import React from 'react';

const Header = ({ onNavigate, onToggleMobileNav, isMobileNavOpen, cinematicMode, onToggleCinematicMode }) => {
  const navItems = [
    { id: 'promo', label: 'Promo Videos' },
    { id: 'music', label: 'Music Videos' },
    { id: 'corporate', label: 'Corporate' },
    { id: 'film', label: 'Film Production' },
    { id: 'about', label: 'About' },
    { id: 'contact', label: 'Contact' }
  ];

  return (
    <header>
      <div className="header-left">
        <div className="logo" onClick={() => onNavigate('home')}>
          JFK<span>PRODUCTIONS</span>
        </div>
        <div className="cinematic-toggle">
          <label className="toggle-switch">
            <input 
              type="checkbox" 
              checked={cinematicMode} 
              onChange={(e) => onToggleCinematicMode(e.target.checked)}
            />
            <span className="slider"></span>
          </label>
          <span className="toggle-label">Cinematic Mode</span>
        </div>
      </div>
      
      <nav>
        <ul>
          {navItems.map(item => (
            <li key={item.id}>
              <a 
                href={`#${item.id}`} 
                className="nav-link" 
                onClick={() => onNavigate(item.id)}
              >
                {item.label}
              </a>
            </li>
          ))}
        </ul>
      </nav>
      
      <div 
        className={`menu-toggle ${isMobileNavOpen ? 'active' : ''}`}
        onClick={onToggleMobileNav}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>
    </header>
  );
};

export default Header;
